<template>
    <ChangeModal ref="modal" help="HelpTeam">
        <span slot="title">Team Description &amp; Visibility</span>
    </ChangeModal>
</template>

<script>
export default {
    label: 'Team Description',
};
</script>
